import { useLayoutEffect, useRef } from 'react'

const COUNTER_FROM = 0.6

export function TextArea({
  value,
  onChange,
  placeholder,
  maxLength = 200,
  optionalLabel,
  autoFocus,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  maxLength?: number
  optionalLabel?: string
  autoFocus?: boolean
}) {
  const ref = useRef<HTMLTextAreaElement>(null)

  useLayoutEffect(() => {
    const node = ref.current
    if (!node || node.value !== value) return
    node.style.height = 'auto'
    const line = 21
    const max = line * 5 + 26
    node.style.height = `${Math.min(node.scrollHeight, max)}px`
    node.style.overflowY = node.scrollHeight > max ? 'auto' : 'hidden'
  }, [value])

  const showCounter = value.length > maxLength * COUNTER_FROM

  return (
    <div>
      <textarea
        ref={ref}
        value={value}
        onChange={(event) => onChange(event.target.value.slice(0, maxLength))}
        placeholder={placeholder}
        autoFocus={autoFocus}
        rows={3}
        className="min-h-textarea w-full resize-none rounded-nested border border-hairline bg-field px-[14px] py-[13px] text-body text-text outline-hidden transition-[background-color,border-color,box-shadow] duration-row placeholder:text-text-muted focus:border-accent focus:bg-field-focus focus:shadow-focus"
      />
      {optionalLabel || showCounter ? (
        <div className="mt-2 flex items-center justify-between text-hint text-text-muted">
          <span>{optionalLabel}</span>
          {showCounter ? (
            <span className="tabular">
              {value.length} / {maxLength}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
